
import React from 'react';
import logo from '../assets/images/Logo.png';
import styles from '../styles/PrivacyPolicy.module.css';

const PrivacyPolicy = () => (
  <div className={styles['privacy-container']}>
    <div className={styles['privacy-header-row']}>
      <div className="aboutus-logo-col">
        <img src={logo} alt="AstroShubh Logo" className={styles['privacy-logo']} />
      </div>
      <div className={styles['privacy-title-col']}>
        <h1 className={styles['privacy-title']}>Privacy Policy</h1>
        <p className={styles['privacy-company-info']}>
          <span><strong>Website:</strong> www.astroshubh.com</span><br/>
          <span><strong>Operated by:</strong> Tara Infotech ("Company")</span><br/>
          <span><strong>Brand Name:</strong> AstroShubh</span>
        </p>
      </div>
    </div>
    <div className={styles['privacy-content']}>
      <h2 className={styles['privacy-main-title']}>Privacy Policy</h2>
      <div className={styles['privacy-section-text']}>
        <p>AstroShubh, operated by Tara Infotech (“AstroShubh”, “Company”, “we”, “our”, or “us”), is committed to safeguarding your personal information and ensuring compliance with applicable privacy and data protection laws. This Privacy Policy explains what information we collect, how we use it, how it is protected, and the rights you have over your data when you use our Website (https://astroshubh.com) and Services.</p>
        <br />
        <p>This Privacy Policy is published in accordance with the Information Technology Act, 2000, the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011, and other applicable laws in India.</p>
        <br />
        <h3>USER CONSENT</h3>
        <p>By accessing and using our Website and Services, you acknowledge that you have read, understood, and agreed to the terms of this Privacy Policy. If you do not agree, you must refrain from using the Website.</p>
        <br />
        <p>Your continued use of the Website constitutes your consent for the collection, storage, processing, and disclosure of your personal information as described herein.</p>
        <br />
        <h3>INFORMATION WE COLLECT</h3>
        <p>We may collect the following categories of information:</p>
        <br />
        <ul>
          <li>Device Information – IP address, browser type, device identifiers, operating system, geo-location, and technical details collected via cookies, log files, pixels, etc.</li>
          <li>Order / Service Information – Name, email, phone, billing/payment details, birth details, and other data shared for reports or purchases.</li>
          <li>Interaction Data – Pages viewed, time spent, referral sources, and interactions with the Website.</li>
          <li>User-Submitted Data – Forms filled, feedback, reviews, comments, and communications.</li>
        </ul>
        <br />
        <h3>USE OF PERSONAL INFORMATION</h3>
        <ul>
          <li>Order Fulfilment: Process payments, deliver reports and services.</li>
          <li>Customer Communication: Respond to queries, confirmations, and support.</li>
          <li>Fraud Prevention: Detect and prevent fraudulent or unauthorized activities.</li>
          <li>Service Improvement: Enhance our Website, Services, and customer experience.</li>
          <li>Marketing & Updates: With your consent, send newsletters and offers (opt-out anytime).</li>
          <li>Legal Compliance: To comply with applicable laws and regulations.</li>
        </ul>
        <br />
        <h3>SHARING OF PERSONAL INFORMATION</h3>
        <p>We do not sell your data. However, we may share information with:</p>
        <br />
        <ul>
          <li>Trusted Service Providers: Payment processors, analytics, and marketing partners.</li>
          <li>Legal Authorities: To comply with laws, court orders, or government regulations.</li>
          <li>Business Transfers: In case of merger, acquisition, or restructuring.</li>
        </ul>
        <br />
        <h3>NEWSLETTERS & COMMUNICATIONS</h3>
        <p>Subscription to newsletters is optional. Frequency: up to 2 issues per month. Users may unsubscribe at any time. We reserve the right to modify or discontinue newsletters without notice.</p>
        <br />
        <h3>DATA RETENTION</h3>
        <p>We retain your personal data as long as necessary for processing, fulfillment, or as required by law. You may request deletion of your data by contacting us, subject to legal retention obligations.</p>
        <br />
        <h3>USER RIGHTS</h3>
        <ul>
          <li>Access your data.</li>
          <li>Request corrections or updates.</li>
          <li>Request deletion of your data.</li>
          <li>Restrict or object to processing.</li>
          <li>Opt-out of marketing communications.</li>
        </ul>
        <br />
        <p>To exercise these rights, contact us at support@astroshubh.com.</p>
        <br />
        <h3>DATA SECURITY</h3>
        <p>We implement strict security measures including encryption, access controls, and regular audits to protect your data against unauthorized access, alteration, or disclosure.</p>
        <br />
        <h3>MINORS</h3>
        <p>Our Services are intended for individuals aged 18 and above. We do not knowingly collect data from children under 14 years. If such data is identified, we will delete it immediately.</p>
        <br />
        <h3>COOKIES & TRACKING</h3>
        <p>We use cookies and similar technologies to enhance experience and analyze traffic. You may disable cookies via browser settings, but some features may not work properly.</p>
        <br />
        <h3>CHANGES TO THIS PRIVACY POLICY</h3>
        <p>We may update this Privacy Policy periodically. Updates will be posted on this page. Continued use of Services after updates constitutes acceptance.</p>
        <br />
        <h3>CONTACT US</h3>
        <p>For any queries regarding this Privacy Policy, please contact us:</p>
        <br />
        <p>📧 support@astroshubh.com</p>
        <br />
        <p>Jurisdiction: Any disputes shall be subject to arbitration in Gurugram, Haryana, India.</p>
      </div>
    </div>
  </div>
);

export default PrivacyPolicy;
